import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-2 py-3"
}
const _hoisted_2 = {
  key: 1,
  class: "px-2 py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_ChatConversation = _resolveComponent("ChatConversation")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { "grid-list": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        "max-width": "900px",
        style: {"margin":"0","margin-bottom":"-1vh"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: _normalizeClass(_ctx.small ? 'static-position' : ''),
            style: {"padding":"10px","position":"static"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                justify: "space-between",
                align: _ctx.small ? 'start' : 'center',
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: _ctx.$vuetify.display.mobile && !_ctx.small ? 12 : 'auto'
                  }, {
                    default: _withCtx(() => [
                      (_ctx.small)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_ctx.chatTitle), 1))
                        : (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.chatTitle), 1))
                    ]),
                    _: 1
                  }, 8, ["cols"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_col, {
                    cols: _ctx.$vuetify.display.mobile && !_ctx.small ? 12 : 'auto'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: _ctx.starredOnly,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.starredOnly) = $event)),
                        label: ` ${_ctx.small ? 'Important' : 'Messages importants'}`,
                        class: _normalizeClass(["pa-2", _ctx.$vuetify.display.mobile && !_ctx.small ? '' : 'text-right']),
                        dense: _ctx.small
                      }, null, 8, ["modelValue", "label", "class", "dense"])
                    ]),
                    _: 1
                  }, 8, ["cols"])
                ]),
                _: 1
              }, 8, ["align"]),
              _createVNode(_component_v_divider)
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.showDiscussion)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                id: "chatMessages",
                ref: "chatMessages",
                style: _normalizeStyle({ padding: 0, overflowY: 'auto', height: _ctx.height })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ChatConversation, {
                    chatType: _ctx.chatType,
                    messages: _ctx.messages,
                    starredOnly: _ctx.starredOnly
                  }, null, 8, ["chatType", "messages", "starredOnly"])
                ]),
                _: 1
              }, 8, ["style"]))
            : _createCommentVNode("", true),
          (_ctx.showDiscussion && !_ctx.starredOnly)
            ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.showDiscussion && !_ctx.starredOnly)
            ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                key: 2,
                class: "mx-2 pt-2 mb-2",
                modelValue: _ctx.messageToSend,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.messageToSend) = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.send()), ["enter"])),
                "append-inner-icon": "$send",
                placeholder: "Saisir votre message...",
                "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (_ctx.send()))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}